import { RecursivePartial } from '@/typings/utils'

function isObject(val: any): boolean {
  return Object.prototype.toString.call(val) === '[object Object]'
}

// 仅对象
export function twoLevelAssignObj<T>(target: T, data: RecursivePartial<T>, level = 2): T {
  if (isObject(target)) {
    let tmp: T = { ...target }
    for (const key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        const oldValue = target[key]
        const value = data[key]
        if (isObject(value) && isObject(oldValue)) {
          tmp = {
            ...tmp,
            [key]: twoLevelAssignObj(oldValue, value, level - 1),
          }
        } else if (!isObject(value) && key in data) {
          tmp = {
            ...tmp,
            [key]: value,
          }
        }
      }
    }
    return tmp
  }
  return target
}

interface RemoveObjEmptyP1 {
  [key: string]: any
}

interface RemoveObjEmptyP2 {
  removeUndefind?: boolean
  removeNull?: boolean
  removeZero?: boolean
}

const defaultRemoveObjEmptyP2Value = {
  removeUndefind: 1,
  removeNull: 1,
  removeZero: 0,
}

/**
 *
 */
export function removeObjEmptyKey(
  obj: RemoveObjEmptyP1,
  option?: RemoveObjEmptyP2,
  customFn?: (key: keyof RemoveObjEmptyP1, value: any, obj: RemoveObjEmptyP1) => boolean
): Partial<RemoveObjEmptyP1> {
  const emptyObj: RemoveObjEmptyP1 = {}
  const { removeNull = 1, removeUndefind = 1, removeZero = 0 } =
    option || defaultRemoveObjEmptyP2Value
  return Object.keys(obj).reduce((pre, cur) => {
    const value = obj[cur]
    let removeFlag = !value

    if (!value) {
      if (typeof customFn === 'function') {
        removeFlag = customFn(cur, value, obj)
      } else if (value === undefined && !!removeUndefind) {
        removeFlag = true
      } else if (value === null && !!removeNull) {
        removeFlag = true
      } else if (value === 0 && !!removeZero) {
        removeFlag = true
      }
    }
    if (removeFlag) {
      return pre
    }
    return { ...pre, [cur]: value }
  }, emptyObj)
}
